import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Badge } from "primereact/badge";
import { TEXT_NORMAL, TEXT_SMALL } from "../../style";
import { getReadableDate, parseAppDateTime } from "../../utils";
import { EMPTY_VALUE, TASK_PRIORITIES } from "../../constants";
import ConfirmationWrapper from "../common/ConfirmationWrapper";

export default function TaskCard({
    id,
    title,
    description,
    status_title,
    status_color,
    priority,
    user_full_name,
    created_by_full_name,
    created_by,
    created_on,
    deadline,
    scope,
    onDelete,
}) {
    const navigate = useNavigate();
    const { id: loggedInUserId } = useSelector((state) => state.stateUser);
    const canDelete = Number(created_by) === Number(loggedInUserId);

    const status = (status_title || "").trim().toLowerCase();
    const deadlineMs = deadline ? parseAppDateTime(deadline) : NaN;
    const isOverdue =
        (status === "open" || status === "in progress") && Number.isFinite(deadlineMs) && deadlineMs < Date.now();
    const cardColor = isOverdue ? "#FEE2E2" : status_color;
    const priorityLabel = TASK_PRIORITIES.find((p) => Number(p.id) === Number(priority))?.label;

    return (
        <div
            className={`border-1 border-round-md flex align-items-center gap-3 p-3 mb-2 cursor-pointer ${
                isOverdue ? "border-red-400" : "border-gray-300"
            }`}
            style={cardColor ? { backgroundColor: cardColor } : undefined}
            onClick={() => navigate(`/user-tasks/${id}`, { state: { fromScope: scope } })}
        >
            <div className="flex flex-column flex-1 min-w-0 gap-1">
                <div className="flex align-items-center gap-2 min-w-0">
                    <span className={`${TEXT_NORMAL} font-semibold white-space-nowrap overflow-hidden text-overflow-ellipsis`}>
                        #{id}. {title}
                    </span>
                    {priorityLabel ? <Badge value={priorityLabel} severity="info" /> : null}
                </div>
                {description ? (
                    <span className={`${TEXT_SMALL} text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis`}>
                        {description}
                    </span>
                ) : null}
                <div className="flex align-items-center gap-2 flex-wrap">
                    {status_title ? <span className={`${TEXT_SMALL} font-semibold`}>{status_title}</span> : null}
                    {scope === "created" ? (
                        <span className={TEXT_SMALL}>To: {user_full_name || EMPTY_VALUE}</span>
                    ) : scope === "all" ? (
                        <>
                            <span className={TEXT_SMALL}>To: {user_full_name || EMPTY_VALUE}</span>
                            <span className={TEXT_SMALL}>By: {created_by_full_name || EMPTY_VALUE}</span>
                        </>
                    ) : (
                        <span className={TEXT_SMALL}>By: {created_by_full_name || EMPTY_VALUE}</span>
                    )}
                    <span className={TEXT_SMALL}>{getReadableDate({ date: created_on })}</span>
                    {deadline ? (
                        <span
                            className={`${TEXT_SMALL} ${
                                isOverdue
                                    ? "font-semibold text-red-700 fadein animation-duration-2000 animation-iteration-infinite"
                                    : ""
                            }`}
                        >
                            Due: {getReadableDate({ date: deadline })}
                        </span>
                    ) : null}
                </div>
            </div>
            {canDelete ? (
                <ConfirmationWrapper action={() => onDelete?.(id)}>
                    <i className="pi pi-trash text-red-500 flex-shrink-0" />
                </ConfirmationWrapper>
            ) : null}
            <i className="pi pi-angle-right text-color-secondary flex-shrink-0" />
        </div>
    );
}
